var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row no-gutters" },
    [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _vm.noCarrierFlag == true
            ? _c("div", { staticClass: "row clearMargin" }, [_vm._m(0)])
            : _vm._e(),
          _vm._v(" "),
          _vm.noCarrierFlag == false
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-6 px-3 my-2 p-2" }, [
                  _c(
                    "fieldset",
                    { staticClass: "border border-primary rounded container " },
                    [
                      _c(
                        "legend",
                        {
                          staticClass:
                            "w-auto px-2 font-weight-bold smaller-font-content text-primary"
                        },
                        [_vm._v("Select Carrier")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "alert alert-primary  py-2 w-70 .mb-4",
                          attrs: { role: "note" }
                        },
                        [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "col d-inline-block my-auto smaller-font-content",
                              domProps: { innerHTML: _vm._s(_vm.infoContent()) }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("input-select", {
                        attrs: { fieldData: _vm.carrierOptionsArr }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isQRPAdmin,
                        expression: "isQRPAdmin"
                      }
                    ],
                    staticClass: "col-12 col-md-6 px-3 my-2 p-2"
                  },
                  [
                    _c(
                      "fieldset",
                      {
                        staticClass: "border border-primary rounded container "
                      },
                      [
                        _c(
                          "legend",
                          {
                            staticClass:
                              "w-auto px-2 font-weight-bold smaller-font-content text-primary"
                          },
                          [_vm._v("Add State Login")]
                        ),
                        _vm._v(" "),
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "b-container",
                          { staticClass: "clearPadding", attrs: { fluid: "" } },
                          [
                            _c(
                              "b-row",
                              { staticClass: "no-gutters" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "minWidthcol",
                                    attrs: {
                                      xl: "3",
                                      lg: "6",
                                      md: "3",
                                      sm: "6"
                                    }
                                  },
                                  [
                                    _c("input-select", {
                                      attrs: { fieldData: _vm.StatesOptionsArr }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "p-2 mt_6 minButtonWidthcol",
                                    attrs: {
                                      xl: "3",
                                      lg: "6",
                                      md: "3",
                                      sm: "6"
                                    }
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-primary addStateBtn ",
                                        attrs: {
                                          type: "submit",
                                          disabled: _vm.requireState
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.AddState($event)
                                          }
                                        }
                                      },
                                      [_vm._v("Add State")]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c(
            "b-container",
            {
              staticClass: "bv-example-row no-gutters clearPadding",
              attrs: { fluid: "" }
            },
            [
              _c(
                "b-row",
                { staticClass: "clearPadding" },
                _vm._l(_vm.addMoreState, function(subItem) {
                  return _c(
                    "b-col",
                    {
                      key: subItem,
                      staticClass: "fixwidth",
                      attrs: { xl: "2", lg: "4", md: "4", sm: "6" }
                    },
                    [
                      _vm.addCrredFlag == true
                        ? _c("carrierLoginUpdater", {
                            attrs: {
                              progID: _vm.progID,
                              state: subItem,
                              permissionRole: _vm.isQRPAdmin,
                              sId: _vm.sId
                            },
                            on: {
                              CredentialUpdateMsg: _vm.UpdateSucessStatus,
                              CredentialSaveFailMsg: _vm.UpdateFailStatus,
                              deleteStateflag: _vm.deletedState
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        {
          staticClass: "bv-example-row no-gutters clearPadding",
          attrs: { fluid: "" }
        },
        [
          _c(
            "b-row",
            { staticClass: "clearPadding" },
            _vm._l(_vm.currentCarriersCred, function(subItem) {
              return _c(
                "b-col",
                {
                  key: subItem.stateCode,
                  staticClass: "fixwidth",
                  attrs: { xl: "2", lg: "4", md: "4", sm: "6" }
                },
                [
                  _vm.editCrredFlag == true && subItem.addStateComp == "false"
                    ? _c("EditcarrierLoginUpdater", {
                        attrs: {
                          progID: _vm.progID,
                          sId: _vm.sId,
                          currentCarriersCred: _vm.currentCarriersCred,
                          permissionRole: _vm.isQRPAdmin,
                          subItem: subItem
                        },
                        on: {
                          CredentialUpdateMsg: _vm.UpdateSucessStatus,
                          CredentialSaveFailMsg: _vm.UpdateFailStatus,
                          deleteStateflag: _vm.deletedState
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editCrredFlag == true && subItem.addStateComp == "true"
                    ? _c("carrierLoginUpdater", {
                        attrs: {
                          state: subItem.stateCode,
                          progID: _vm.progID,
                          sId: _vm.sId,
                          permissionRole: _vm.isQRPAdmin
                        },
                        on: {
                          CredentialUpdateMsg: _vm.UpdateSucessStatus,
                          CredentialSaveFailMsg: _vm.UpdateFailStatus,
                          deleteStateflag: _vm.deletedState
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col alert alert-warning text-left smaller-font-content py-2 mt-4",
        attrs: { role: "alert" }
      },
      [
        _c("div", { staticClass: "row no-gutters" }, [
          _c(
            "div",
            { staticClass: "d-inline-block my-auto mr-2 align-middle" },
            [_c("i", { staticClass: "fas fa-exclamation-circle" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-inline-block col" }, [
            _c("strong", [_vm._v("Oops!")]),
            _vm._v(
              " It looks like there are no direct integration carriers configured for this agency."
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
      _c("img", {
        attrs: {
          width: "20px",
          height: "20px",
          src: require("../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "alert alert-primary  py-2 w-70 smallerPaddingAlert .mb-4",
        attrs: { role: "note" }
      },
      [
        _c("div", { staticClass: "row no-gutters" }, [
          _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
            _c("img", {
              attrs: {
                width: "16px",
                height: "16px",
                src: require("../../../assets/info-circle-blue.svg"),
                alt: "info"
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col d-inline-block my-auto smaller-font-content" },
            [
              _vm._v(
                "Some states may not be appointed for this agency or will not have a direct integration for this carrier.\n            "
              )
            ]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("hr", {
          staticClass: "border border-primary",
          attrs: { id: "carrier-hr-bottom" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fc25254", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fc25254","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/agencies/CarrierCredentialUpdater.vue
// module id = null
// module chunks = 